import { LEFT_NAVIGATION_PAGE_URL } from "./src/models/navigation.models"

const paths = {
    [LEFT_NAVIGATION_PAGE_URL.GLOBALBALLOTQUEUE]: {
        parent: [{label: "Dashboard", route: LEFT_NAVIGATION_PAGE_URL.HOME}],
        page: {label: "Ballot Queue", route: LEFT_NAVIGATION_PAGE_URL.GLOBALBALLOTQUEUE}
    },
    [LEFT_NAVIGATION_PAGE_URL.MANAGE_ANSI_COMMITTEE_STANDARD]: {
        parent: [{label: "Dashboard", route: LEFT_NAVIGATION_PAGE_URL.HOME}],
        page: {label: "Manage ANSI Committee/Standard", route: LEFT_NAVIGATION_PAGE_URL.MANAGE_ANSI_COMMITTEE_STANDARD}
    },
    [LEFT_NAVIGATION_PAGE_URL.MANAGE_BSR108]: {
        parent: [{label: "Dashboard", route: LEFT_NAVIGATION_PAGE_URL.HOME}],
        page: {label: "Manage BSR108", route: LEFT_NAVIGATION_PAGE_URL.MANAGE_BSR108}
    },
    [LEFT_NAVIGATION_PAGE_URL.MANAGE_BSR109]: {
        parent: [{label: "Dashboard", route: LEFT_NAVIGATION_PAGE_URL.HOME}],
        page: {label: "Manage BSR109", route: LEFT_NAVIGATION_PAGE_URL.MANAGE_BSR109}
    },
    [LEFT_NAVIGATION_PAGE_URL.ANSI_AUDIT_LOG]: {
        parent: [{label: "Dashboard", route: LEFT_NAVIGATION_PAGE_URL.HOME}],
        page: {label: "ANSI Audit Log", route: LEFT_NAVIGATION_PAGE_URL.ANSI_AUDIT_LOG}
    },
    [LEFT_NAVIGATION_PAGE_URL.PINS_REPORTS]: {
        parent: [{label: "Dashboard", route: LEFT_NAVIGATION_PAGE_URL.HOME}],
        page: {label: " PINS Reports", route: LEFT_NAVIGATION_PAGE_URL.PINS_REPORTS}
    }
}

export default paths;